var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-block px-4 1py-3 1pt-md-5 1pb-md-4 mx-auto1 text-center1"},[_c('h1',{staticClass:"display-4"},[_vm._v("Learn to match outfits")]),_vm._v(" "),_c('p',{staticClass:"lead mb-5"},[_vm._v("Develop personal style through experimentation")]),_vm._v(" "),_c('div',{staticClass:"buttons-wrapper"},[_vm._t("form")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45085329","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/IntroBlock.vue
// module id = sm/S
// module chunks = 0